import { useEffect, useState } from "react";
import whatInput from "what-input";
export const useWhatInput = ({ strategy = "input" } = {}) => {
    const [inputType, setInputType] = useState(whatInput.ask(strategy));
    useEffect(() => {
        const updateInputType = (nextInputType) => setInputType(nextInputType);
        updateInputType(whatInput.ask(strategy));
        whatInput.registerOnChange(updateInputType, strategy);
        return () => {
            whatInput.unRegisterOnChange(updateInputType);
        };
    }, [strategy]);
    return { inputType };
};
